"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Initializer;
var _lodash = _interopRequireDefault(require("lodash"));
var _store = _interopRequireDefault(require("@/store"));
function Initializer() {
  _store.default.dispatch('AUpdateScreen');
  window.onresize = _lodash.default.debounce(() => {
    _store.default.dispatch('AUpdateScreen');
  }, 300);
}